<h1 class="mb-2 text-22 text-center">Update Password</h1>
<form class="fade-in" [formGroup]="updatePasswordForm" (ngSubmit)="submit()">
    <div class="form-group">
        <label for="email">Email Address</label>
        <input type="email" class="form-control"  id="email" placeholder="Enter Email Address" formControlName="email"
               [class.is-invalid]="updatePasswordForm.get('email').invalid && updatePasswordForm.get('email').touched">
        <div class="k-form-error" *ngIf="updatePasswordForm.get('email').invalid && (updatePasswordForm.get('email').touched ||
    updatePasswordForm.get('email').dirty)">
            <div *ngIf="updatePasswordForm.get('email').hasError('required') || updatePasswordForm.get('email').hasError('whitespace')">
                Email Address is required
            </div>
            <div *ngIf="updatePasswordForm.get('email').hasError('email')">
                Invalid Email Address
            </div>
        </div>
    </div>

    <div class="form-group">
        <label for="password">Password</label>
        <input type="password" class="form-control" placeholder="Enter Password" id="password" formControlName="password"
               [class.is-invalid]="updatePasswordForm.get('password').invalid && updatePasswordForm.get('password').touched">
        <div class="k-form-error" *ngIf="updatePasswordForm.get('password').invalid && (updatePasswordForm.get('password').touched || updatePasswordForm.get('password').dirty)">
            <div *ngIf="updatePasswordForm.get('password').hasError('required')">
                Password is required
            </div>
            <div *ngIf="updatePasswordForm.get('password').hasError('minLength')">
                Password must be more than 6 Characters
            </div>
        </div>
    </div>

    <div class="form-group">
        <label for="cPassword">Confirm Password</label>
        <input type="password" class="form-control" placeholder="Confirm Password" id="cPassword" formControlName="password_confirmation"
               [class.is-invalid]="updatePasswordForm.get('password_confirmation').invalid && updatePasswordForm.get('password_confirmation').touched">
        <div class="k-form-error" *ngIf="updatePasswordForm.get('password_confirmation').invalid && (updatePasswordForm.get('password_confirmation').touched || updatePasswordForm.get('password_confirmation').dirty)">
            <div *ngIf="updatePasswordForm.get('password_confirmation').hasError('required')">
                Password Confirmation  is required
            </div>
            <div *ngIf="updatePasswordForm.get('password_confirmation').hasError('compare')">
                Password does not match
            </div>
        </div>
    </div>

    <button type="submit" class="btn btn-rounded btn-primary primary-btn btn-block mt-4" [class.k-loader--loading]="state.post">
        Submit <span class="k-loader k-loader--light k-loader--right" *ngIf="state.post"></span>
    </button>
</form>
<div class="mt-3 text-center">
    <a class="text-muted" (click)="goBack()">
        <u>Go Back</u>
    </a>
</div>
